import { IFormBuilderAssistant } from '../../../shared/components/form-builder/form-builder-assistant/iform-builder-assistant.interface';
import { FormField } from '../../../shared/models/form-builder/form-field.model';
import { FieldDefinitionService } from '../../../shared/services/field-definition.service';

// Implement a class that implements form builder interface IFormBuilderAssistant.
export class FormTemplateDesign_FormBuilderAssistant implements IFormBuilderAssistant {
    public get initiallyExpandedFieldGroup(): string {
        return 'Input Fields';
    }
    public get titleCanBeConfigured(): boolean {
        return true;
    }

    public filterConditionalLogicSourceFields(fieldDefinitionService: FieldDefinitionService, formFields: FormField[]): FormField[] {
        // Note:  this method returns all fields unfiltered by design.
        return formFields;
    }

    public canOnlyEditHtmlFields(): boolean {
        return false;
    }
    public canEditField(fieldDefinitionService: FieldDefinitionService, formField: FormField): boolean {
        return true;
    }
    public canEditTemplateProperties(): boolean {// Applies to site home pages as well, so where the term 'Template' is used in a general way.
        return true;
    }

    // Constructor.
    public constructor() { }
}
